import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguage } from './utils';

const resourcesLangTranslationEn = {
  'Round Trip': 'Round Trip',
  'One Way': 'One Way',
  'Multi-city': 'Multi-city',
  From: 'From',
  To: 'To',
  Depart: 'Depart',
  Return: 'Return',
  'Select passengers': 'Select passengers',
  'Promo Code': 'Promo Code',
  Currency: 'Currency',
  Baht: 'Thai - Baht',
  Dollar: 'US - Dollar',
  Yuan: 'China - Yuan',
  Rupee: 'India - Rupee',
  'Lowest fare': 'Lowest fare',
  Search: 'Search',
  'No destinations available': 'No destinations available',
  'Type at least two characters to search': 'Type at least two characters to search',
  'No results found': 'No results found',
  // placeholders
  'Select Origin': 'Select Origin',
  'Select Destination': 'Select Destination',
  // passengers
  adult: 'adult',
  adults: 'adults',
  child: 'child',
  children: 'children',
  infant: 'infant',
  infants: 'infants',
  Age: 'Age',
  'Enter the age at last day of the trip': 'Enter the age at last day of the trip',
  'Add trip': 'Add trip',
  Trip: 'Trip {{number}}',
  Loading: 'Loading...',
} as const;

type ResourcesLangTranslationType = Record<keyof typeof resourcesLangTranslationEn, string>;

const resourcesLangTranslationTh: ResourcesLangTranslationType = {
  'Round Trip': 'ไป-กลับ',
  'One Way': 'เที่ยวเดียว',
  'Multi-city': 'หลายเส้นทาง',
  From: 'ต้นทาง',
  To: 'ปลายทาง',
  Depart: 'ขาไป',
  Return: 'ขากลับ',
  'Select passengers': 'เลือกผู้โดยสาร',
  'Promo Code': 'รหัสโปรโมชั่น',
  Currency: 'สกุลเงิน',
  Baht: 'ไทย - บาท',
  Dollar: 'สหรัฐ - ดอลล่าร์',
  Yuan: 'จีน - หยวน',
  Rupee: 'อินเดีย - รูปีอินเดีย',
  'Lowest fare': 'ราคาต่ำสุด',
  Search: 'ค้นหา',
  'No destinations available': 'ไม่มีจุดหมายปลายทาง',
  'Type at least two characters to search': 'พิมพ์อักขระอย่างน้อยสองตัวเพื่อค้นหา',
  'No results found': 'ไม่พบผลลัพธ์',
  // placeholders
  'Select Origin': 'เลือกต้นทาง',
  'Select Destination': 'เลือกปลายทาง',
  // passengers
  adult: 'ผู้ใหญ่',
  adults: 'ผู้ใหญ่',
  child: 'เด็ก',
  children: 'เด็ก',
  infant: 'ทารก',
  infants: 'ทารก',
  Age: 'อายุ',
  'Enter the age at last day of the trip': 'ป้อนอายุ ณ วันสุดท้ายของการเดินทาง',
  'Add trip': 'เพิ่มการเดินทาง',
  Trip: 'การเดินทาง {{number}}',
  Loading: 'กำลังโหลด',
};

const resourcesLangTranslationZh: ResourcesLangTranslationType = {
  'Round Trip': '往返',
  'One Way': '单程',
  'Multi-city': '多城市',
  From: '出发地',
  To: '目的地',
  Depart: '去程',
  Return: '回程',
  'Select passengers': '選擇乘客',
  'Promo Code': '优惠代码',
  Currency: '货币',
  Baht: '泰銖',
  Dollar: '美元',
  Yuan: '人民币',
  Rupee: '印度盧比',
  'Lowest fare': '最低票價',
  Search: '搜索',
  'No destinations available': '沒有可用的目的地',
  'Type at least two characters to search': '輸入至少兩個字符進行搜索',
  'No results found': '未找到結果',
  // placeholders
  'Select Origin': '選擇原點',
  'Select Destination': '選擇目的地',
  // passengers
  adult: '成人',
  adults: '成年人',
  child: '孩子',
  children: '孩子們',
  infant: '嬰兒',
  infants: '嬰兒',
  Age: '年齡',
  'Enter the age at last day of the trip': '輸入旅行最後一天的年齡',
  'Add trip': '添加行程',
  Trip: '旅行 {{number}}',
  Loading: '加載中',
};

const resources: Record<string, { translation: ResourcesLangTranslationType }> = {
  en: { translation: resourcesLangTranslationEn },
  th: { translation: resourcesLangTranslationTh },
  zh: { translation: resourcesLangTranslationZh },
};

void (async () => {
  await i18n.use(initReactI18next).init({ resources, interpolation: { escapeValue: false } });
  await i18n.changeLanguage(getLanguage());
})();

export default i18n;
